import styles from '../DocumentCentre.module.css';
import { formatMoney } from '../documentCentre.constants';

/**
 * Summary cards (spec §4). Every card states whether it counts documents,
 * bookings or amounts; the API builds them from exactly the filtered rows.
 * Count cards that map to a filter are clickable and apply that filter.
 */
const SummaryCards = ({ cards, loading, onCardFilter }) => {
  if (loading && !cards?.length) {
    return (
      <div className={styles.summaryBar}>
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={styles.summaryCard}>
            <span className={styles.summarySkeleton} style={{ width: '45%', height: 10 }} />
            <span className={styles.summarySkeleton} />
          </div>
        ))}
      </div>
    );
  }
  if (!cards?.length) return null;

  return (
    <div className={styles.summaryBar}>
      {cards.map((card) => {
        const clickable = Boolean(onCardFilter?.[card.key]);
        const content = (
          <>
            <span className={styles.summaryLabel}>{card.label}</span>
            <span className={card.format === 'money' ? styles.summaryValueAmt : styles.summaryValue}>
              {card.format === 'money' ? formatMoney(card.value) : card.value}
            </span>
            {card.sub && <span className={styles.summarySub}>{card.sub}</span>}
          </>
        );
        return clickable ? (
          <button
            type="button"
            key={card.key}
            className={`${styles.summaryCard} ${styles.summaryCardButton}`}
            onClick={onCardFilter[card.key]}
            title="Show these documents"
          >
            {content}
          </button>
        ) : (
          <div key={card.key} className={styles.summaryCard}>
            {content}
          </div>
        );
      })}
    </div>
  );
};

export default SummaryCards;
